import {Suspense} from 'react';
import NavigationLoader from '@/app/(main)/NavigationLoader';

/**
 * 방송국 전용 NavigationLoader 컴포넌트
 */
const ChannelNavigationLoader = () => {
  return (
    <Suspense>
      <NavigationLoader />
    </Suspense>
  );
};

export default ChannelNavigationLoader;
